<script lang="ts" setup>
interface Props {
  imgUrl: string;
}
defineProps<Props>();

const isImageWithError = ref(false);
</script>

<template>
  <!-- Show the SVG fallback if image failed to load, otherwise show the profile image -->
  <template v-if="isImageWithError">
    <div
      class="w-6 h-6 flex justify-center items-center rounded-full bg-[#d9d9d9]"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide text-black lucide-user-icon lucide-user w-4 h-4"
      >
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    </div>
  </template>
  <img
    v-else
    :src="imgUrl"
    class="w-6 aspect-square rounded-full"
    alt=""
    @error="isImageWithError = true"
  />
</template>
